
import fConsts from './featureConstants'

export default  {
 features : [
        {
                title : "Global Functions",
                feature_category : "Global Functions",
                feature_name : fConsts.FleetDashBoard,
                navigateUrl:"",
                featuteIcon : require('../images/mainmenu/users.svg').default,
                productedRoutes : [
                "/reportManagement",
                "/reportManagement/production",
                "/reportManagement/utilization",
                "/reportManagement/clean",
                '/reportManagement/filtration',
                '/reportManagement/oilUsage',
                '/reportManagement/tpmValue',
                '/dashBoardLocations',
                '/dashBoardLocations/specificLocation',
                '/dashBoardLocations/unitsView',
                '/dashBoardUnits',
                '/locationsView',
                '/locationsView/filterBy',
                '/locationsView/filterBy/filterByCountry',
                '/locationsView/filterBy/filterByRegion',
                '/locationsView/filterBy/filterByLocation',
                '/locationsView/filterBy/filterByCustomer',
                '/locationsView/filterBy/filterByBrand',
                '/locationsView/filterBy/filterByModel',
                '/unitsView',
                '/locationsMap',
                '/unitsMap'
                ],
                isMainMenu: false,
                featureAvailable:true
        },
        {
            title :"User Profile",
            feature_category : "Global Functions",
            feature_name : fConsts.UserProfile,
            navigateUrl:"/myInformation",
            featuteIcon : require('../images/mainmenu/users.svg').default,
            productedRoutes : ["/myInformation","/myinformationedit","/assignedUnitGroups","/assignedUnitGroupsEdit","/managePassword","/timeNumberFormatedit","/termsPricingCondition"],
            isMainMenu: false,
            featureAvailable:true
    
        },
        {
            title :"Notifications",
            feature_category : "Global Functions",
            feature_name : fConsts.Notifications,
            navigateUrl:"/notificationManagementView",
            featuteIcon : require('../images/mainmenu/users.svg').default,
            productedRoutes : ["/notificationManagementView","/notificationManagement"],
            isMainMenu: false,
            featureAvailable:true
        },       
        {
            title: "Organization Management",
            feature_category : "Main Menu Apps",
            feature_name : fConsts.SiteManagement,
            navigateUrl:"/organizationManagement",
            featuteIcon : require('../images/mainmenu/OrganizationMgmt.svg').default,
            productedRoutes : ["/organizationManagement","/smartgroupslist","/createnewsmartgrp","/smartGrpTopology","/smartGrpAssignUpdateList","/editsmartgrp","/purposesList","/editsmartGrpTopology","/editsmartGrpAssignUpdateList"],
            isMainMenu: true,
            featureAvailable:true,
            linkTitle: "Organization Management",
            stringID: 'KC0519'
        },       
        {
            title:"Unit Registration",
            feature_category : "Main Menu Apps",
            feature_name : fConsts.UnitRegistration,
            navigateUrl:"/unitRegistration",
            featuteIcon : require('../images/mainmenu/UnitRegistrationAssignment.svg').default,
            productedRoutes : ["/unitRegistration","/addUnit","/assignUnitToTopology","/bulkUnitOnboarding","/bulkUnitOnboardingConfirmation"],
            isMainMenu: true,
            featureAvailable:true,
            linkTitle: "Unit Registration and Assignment",
            stringID: "KC1684"
        },   
        {
            title :"Smart Tag Management",
            feature_category : "Main Menu Apps",
            feature_name : fConsts.smartTag,
            navigateUrl:"/smartTag/tagList",
            featuteIcon : require('../images/mainmenu/smartTagNew.svg').default,
            productedRoutes : ["/smartTag/tagList","/smartTag/createOrgTag","/smartTag/createUnitTag","/smartTag/smartTagTopology","/smartTag/smartTagUnitList","/smartTag/smartTagConfirmation"],
            isMainMenu: true,
            featureAvailable:true,
            linkTitle: "Smart Tag Management",
            stringID: "KC2318"
        },
        {
            title :"User Management",
            feature_category : "Main Menu Apps",
            feature_name : fConsts.UserManagement,
            navigateUrl:"/user/list",
            featuteIcon : require('../images/mainmenu/users.svg').default,
            productedRoutes : ["/user/list","/user/create","/user/edit","/user/select-role","/assignUserToTopology","/role/list","/role/add","/role/edit/:roleId"],
            isMainMenu: true,
            featureAvailable:true,
            linkTitle: "User Management",
            stringID: "KC0581"
        },       
        {
            title: "Subscription",
            feature_category : "Main Menu Apps",
            feature_name : fConsts.Subscription,
            navigateUrl:"/subscription",
            featuteIcon : require('../images/mainmenu/warranty.svg').default,
            productedRoutes : ["/subscription"],
            isMainMenu: true,
            featureAvailable: false,
            linkTitle: "Subscription",
            stringID: "KC1775"
        },
        {
            title:"Menu & Unit Settings",
            feature_category : "Main Menu Apps",
            feature_name : fConsts.Menus,
            navigateUrl:"/menuBrands",
            featuteIcon : require('../images/mainmenu/menu.svg').default,
                        productedRoutes : ["/menuBrands","/menuUpdateStatus","/menuUploadStatus","/menuScheduleUpdateNow","/menuLibrary","/addNewMenuLibrary","/menuAssignUpdateList","/libraryList","/legacyLibraryList","/assignLegacyRecipeToTopology", "/assignLegacyCookbookToTopology", "/uploadLegacyCookbookToTopology","/legacyScheduleUpdateNow", "/libraryScheduleUpdateNow","/legacySelectDevice","/uploadLegacySelectDevice","/librarySelectDevice","/recipeCreation","/stageInformation","/recipeEditor", "/recipeCreationSave", "/assignLibraryToTopology", "/legacyAssignUpdateList", "/libraryAssignUpdateList", "/fileRetrievalList", "/cookbookEditor", "/settingsEditor", "/settingsModes", "/preHeat", "/temperatureBand", "/timerForTemperature", "/sound", "/units", "/password", "/managerPassword", "/servicePassword", "/languages", "/cleaning", "/screensaver", "/changeScreensaver", "/dateAndTime", "/dateAndTimeSettings", "/timezone", "/scheduler", "/schedulerAdd", "/assignSettingsToTopology", "/retrieveLibraryToTopology", "/cookbookAddCategory","/cookbookPressAndGo", "/cookbookParameters", "/menurcPressAndGo","/cookbookRecipeList","/cookbookAddRecipes","/cookbookFavouritesList","/assignCookbookToTopology","/libraryAssignTopology","/legacyAssignTopology","/menuApps","/menuConvolink", "/cookbookSubCategoryList", "/cookbookAddSubCategory", "/recipeAssignTopology", "/frymasterRecipeEditor", "/frymasterRecipeTypeSelection", "/frymasterMultiSegment", "/frymasterRecipeCreation", "/frymasterActionPrompt", "/frymasterRecipeSchedule", "/frymasterRecipeReview", "/assignFrymasterRecipeToTopology", "/frymasterMenuEditor", "/frymasterMenuAdd", "/frymasterMenuList", "/frymasterMenuRecipeList", "/frymasterMenuAddRecipes", "/frymasterMenuShareFrypot", "/frymasterMenuAddFinalReview", "/frymasterMenuSelectFrypots", "/frymasterMenuAutoChange","/frymasterMenuLimitedOffer","/frymasterMenuLimitedOfferTime", "/assignFrymasterMenuToTopology","/frymasterSettings","/frymasterGeneralSettings","/frymasterTimeDate","/frymasterLocale","/frymasterScreen","/frymasterSound","/frymasterLanguage","/frymasterTemperature","/frymasterConfig","/frymasterLanguageSelection","/frymasterHeating","/frymasterPerformanceTest","/frymasterCooking","/frymasterCookingMenu","/frymasterCookingLaneConfiguration","/frymasterCookingProductDisplay","/frymasterCookingInstantOn","/frymasterCookingSmartCook","/frymasterCookingBasketLift","/frymasterCookingOilCondition","/frymasterUserAccess","/frymasterFiltration","/frymasterFiltrationGeneral","/frymasterFiltrationAfterCook","/frymasterOQS","/frymasterOQSOilType","/frymasterOQSReadingDisplay","/frymasterEcoMode","/frymasterAutomaticEcoMode","/frymasterFryerFreshOilType","/frymasterFryerDisposeOilType","/frymasterFryerPotCoverPrompt","/frymasterDaylightSavingSelection","/frymasterDaylightSaving","/frymasterEcoModeScheduled","/assignFrymasterSettingsToTopology", "/uploadSelectDevice", "/assignLegacyMenuToTopology","/menuAddgroupsList","/menuTransfergroupsList", "/menuAssigngroupTopology", "/menuAssignTopology", "/menuTransferUnits","/menuSmartGroupsList","/menuStatus","/menuSmartGroupStatus","/readyRecipeLibraryList","/legacyReadyRecipeLibraryList", "/readyRecipeSelectDevice", "/libraryUploadTopology", "/menuLibraryUpload","/garlandRecipeEditor", "/garlandRecipeCreation", "/garlandRecipeCreationSteps", "/garlandCookbookCreation", "/garlandCookbookEditor","/garlandCookbookAddMenu", "/garlandCookbookAddRecipe","/garlandCookbookAddRecipeItem","/garlandCookbookProduct","/garlandCookbookProductCreation","/garlandCookbookProductRecipe","/garlandLibraryToTopology","/garlandCookbookToTopology","/copyLibrary","/assignCopyLibraryToTopology","/menuAllRecipes","/cookbookAllRecipes"], 
            isMainMenu: true,
            featureAvailable: true,
            linkTitle: "Menu & Unit Settings",
            stringID: "KC1776"
        },
        {
            title:"Ready Recipe",
            feature_category : "Main Menu Apps",
            feature_name : fConsts.readyRecipe,
            navigateUrl:"/readyRecipeLibraryList",
            featuteIcon : require('../images/mainmenu/menu.svg').default,
            productedRoutes : ["/readyRecipeLibraryList","/legacyReadyRecipeLibraryList", "/readyRecipeSelectDevice"],
            isMainMenu: false,
            featureAvailable: true,
            linkTitle: "Ready Recipe",
            stringID: "KC0640"
        },
        {
            title:"Media Management",
            feature_category : "Main Menu Apps",
            feature_name : fConsts.MediaManagement,
            navigateUrl:"/mediaLibraryList",
            featuteIcon : require('../images/mainmenu/cloud.svg').default,
            productedRoutes : ["/mediaLibraryList","/mediaPreparation","/mediaScreenSaver","/mediaPackage","/mediaCompilation","/mediaUploadHistory","/assignMediaList","/assignPackageMedia","/assignMedia","/assignMediaUpdateList", "/mediaImageLibrary", "/mediaAudioLibrary","/assigngroupTopology", "/assignmedialistView","/assignmediaconform", "/assignmediatopology","/mediaStatus","/mediaSmartGroupStatus","/mediaTransferUnits","/mediaAssignSmartGroupsList","/organizationChartView","/organizationChartListView"],
            isMainMenu: true,
            featureAvailable:true,
            linkTitle: "Media Management",
            stringID: "KC0632"
        },
        {
            title:"Software Management",
            feature_category : "Main Menu Apps",
            feature_name : fConsts.SoftwareManagement,
            navigateUrl:"/softwareLibraryList",
            featuteIcon : require('../images/mainmenu/plugins.svg').default,
            productedRoutes : ["/softwareAvailableUpdates","/bakingPlan","/softwareUpdatesStatus","/assignUpdateList","/assignUpdateTopology","/softwareScheduleUpdate", "/softwareLibraryList", "/softwareAssignmedialistView", "/softwareLibraryUpdate","/softwareSmartGroupsList","/softwareTransferSmartgroupsList", "/softwareAssignlistView","/softwareAssigngroupTopology", "/softwareTransferUnits","/softwareAssignSmartgroupsList","/softwareStatus","/softwareSmartGroupStatus"],
            isMainMenu: true,
            featureAvailable:true,
            linkTitle: "Software Management",
            stringID: "KC0633"
        },
        {
            title: "HACCP Management",
            feature_category: "Main Menu Apps",
            feature_name: fConsts.HaccpManagement,
            navigateUrl: "/haccpBrands",
            featuteIcon: require('../images/mainmenu/haccp.svg').default,
            productedRoutes: ["/haccpBrands","/haccpLogLibrary","/haccpRetrieveStatus","/haccpViewer","/haccpAssignUpdateList"],
            isMainMenu: true,
            featureAvailable: true,
            linkTitle: "HACCP Management",
            stringID: "KC0636"
        },
        {
            title: "Report Management",
            feature_category: "Main Menu Apps",
            feature_name: fConsts.ReportManagement,
            navigateUrl: "/reportList",
            featuteIcon: require('../images/mainmenu/report.svg').default,
            productedRoutes: ["/reportList", "/scheduledReportList", "/newReport", "/reportAssignUpdateList","/brandReportList","/assignReportUnitToTopology","/newReportWithOptions","/fryerReport","/reportAssignStoreList","/garlandReport","/automatedEmailSettings"],                        
            isMainMenu: true,
            featureAvailable: true,
            linkTitle: "Report Management",
            stringID: "KC1000"
        },
        {
            title: "KC API Portal",
            feature_category: "Main Menu Apps",
            feature_name: fConsts.C2CAPIDeveloperPortal,
            navigateUrl: "/c2cSwaggerListView",
            featuteIcon: require('../images/mainmenu/swagger.png'),
            productedRoutes: ["/c2cSwaggerListView","/swaggerInterface","/swaggerUiComponent"],
            isMainMenu: true,
            featureAvailable: true,
            linkTitle: "KC API Portal",
            stringID: "KC0637"
        },
        {
            title: "Settings - Product Selection",
            feature_category: "Main Menu Apps",
            feature_name: fConsts.prodSelSetting,
            navigateUrl: "/displayedproducts",
            featuteIcon: require('../images/mainmenu/settings.svg').default,
            productedRoutes: ["/displayedproducts","/productsselection"],
            isMainMenu: true,
            featureAvailable: true,
            linkTitle: "Settings - Product Selection",
            stringID: "KC0770"
        },
        {
            title :"Unit Dashboard",
            feature_category : "Unit Data",
            feature_name : fConsts.UnitDashBoard,
            navigateUrl:"/unitDashboard",
            featuteIcon : require('../images/mainmenu/users.svg').default,
            productedRoutes : ["/unitDashboard","/_dashboard/:serialNo/:menuName/:tabName?"],
            isMainMenu: false,
            featureAvailable:true,
            className:"dashboardNav",
            linkTitle:"Unit Dashboard",
            stringID:"KC0149"
        },
        {
            title :"Reports & Analytics",
            feature_category : "Unit Data",
            feature_name : fConsts.Report,
            navigateUrl:"/reportManagement",
            featuteIcon : require('../images/mainmenu/users.svg').default,
            productedRoutes : ["/reportManagement"],
            isMainMenu: false,
            featureAvailable:true,
            className:"reportNav",
            linkTitle:"Reports & Analytics",
            stringID:"KC0150"
        },
        {
            title :"Service Management",
            feature_category : "Unit Data",
            feature_name : fConsts.Service,
            navigateUrl:"/serviceManagement",
            featuteIcon : require('../images/mainmenu/users.svg').default,
            productedRoutes : ["/serviceManagement","/troubleShooting","/serviceManagement/historicErrors"],
            isMainMenu: false,
            featureAvailable:true,
            className:"serviceNav",
            linkTitle:"Service Management",
            stringID:"KC0151"
        },
        {
            title :"Quality Management",
            feature_category : "Unit Data",
            feature_name : fConsts.Quality,
            navigateUrl:"/unitQualityPerformance",
            featuteIcon : require('../images/icons/quality.svg').default,
            productedRoutes : ["/unitQualityPerformance"],
            isMainMenu: false,
            featureAvailable:true,
            className:"qualityNav",
            linkTitle:"Quality Management",
            stringID:"KC0428"
        },
        {
            title :"Device Log Downloads",
            feature_category : "Unit Data",
            feature_name : fConsts.DeviceLogDownloads,
            navigateUrl:"",
            featuteIcon : require('../images/icons/quality.svg').default,
            productedRoutes : [],
            isMainMenu: false,
            featureAvailable:true,            
        },
        {
            title :"Unit Data",
            feature_category : "Unit Data",
            feature_name : fConsts.EmailErrorReport,
            navigateUrl:"",
            featuteIcon : require('../images/mainmenu/plugins.svg').default,
            productedRoutes : [],
            isMainMenu: false,
            featureAvailable:true
        },
        {
            title :"Media",
            feature_category : "Unit Data",
            feature_name : fConsts.MediaLibrary,
            navigateUrl:"/mediaLibrary",
            featuteIcon : require('../images/mainmenu/users.svg').default,
            productedRoutes : ["/mediaLibrary","/cremMediaPreperation"],
            isMainMenu: false,
            featureAvailable:true,
            className:"recipeNav",
            linkTitle:"Media",
            stringID:"KC0152"
        },
        {
            title :"Asset Management",
            feature_category : "Unit Data",
            feature_name : fConsts.Asset,
            navigateUrl:"/unitManagement",
            featuteIcon : require('../images/mainmenu/users.svg').default,
            productedRoutes : ["/unitManagement"],
            isMainMenu: false,
            featureAvailable:true,
            className:"unitNav",
            linkTitle:"Asset Management",
            stringID:"KC0253"
        },
        {
            title :"Error Center",
            feature_category : "Main Menu Apps",
            feature_name : fConsts.ErrorCenter,
            navigateUrl:"/allcurrenterrors",
            featuteIcon : require('../images/mainmenu/errors.svg').default,
            productedRoutes : ["/allcurrenterrors","/allhistoricerrors"],
            isMainMenu: true,
            featureAvailable:true,
            linkTitle: "Error Center",
            stringID: "KC0639"
        },
        {
            title :"Event Library",
            feature_category : "Main Menu Apps",
            feature_name : fConsts.EventCenter,
            navigateUrl:"/eventLibrary",
            featuteIcon : require('../images/mainmenu/notifications.svg').default,
            productedRoutes : ["/eventLibrary"],
            isMainMenu: true,
            featureAvailable:true,
            linkTitle: "Automated Notification Management [Beta]",
            stringID: "KC1696"
        }, 
        {
            title :"KitchenConnect - How To",
            feature_category : "Main Menu Apps",
            feature_name : fConsts.HowToPage,
            navigateUrl:"/howTo",
            featuteIcon : require('../images/mainmenu/Help.svg').default,
            productedRoutes : ["/howTo"],
            isMainMenu: true,
            featureAvailable:true,
            linkTitle: "KitchenConnect - How To",
            stringID: "KitchenConnect - How To"
        }, 
        {
            title :"Live Monitoring",
            feature_category : "Unit Data",
            feature_name : fConsts.liveMonitoring,
            navigateUrl:"/",
            productedRoutes : ["/liveMonitoring"],
            isMainMenu: false,
            featureAvailable:false,
            linkTitle: "Live Monitoring",
            stringID: "KC2392"
        },
        {
            title :"Subscription Management",
            feature_category : "Main Menu Apps",
            feature_name : fConsts.subscriptionManagement,
            featuteIcon : require('../images/mainmenu/BillingPortal.svg').default,
            navigateUrl:"/subscription/dashboard",
            productedRoutes : ["/subscription/plan", "/subscription/invoice","/subscription/dashboard", "/subscription/manageSubscription","/subscription/payments", "/subscription/manageAccount"],
            isMainMenu: true,
            featureAvailable:true,
            linkTitle: "Subscription Management",
            stringID: "KC1668"
        },
        {
            title: "KitchenConnect - How To",
            feature_category: "Main Menu Apps",
            feature_name: "How To Manual",
            featuteIcon: require('../images/mainmenu/Help.svg').default,
            navigateUrl: "/howTo",
            productedRoutes: ["/howTo"],
            isMainMenu: true,
            featureAvailable: true,
            linkTitle: "KitchenConnect - How To",
            stringID: "KC2886"
        }
    ]
}